import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

var lang;

if (JSON.parse(localStorage.getItem('local'))) {
	lang = JSON.parse(localStorage.getItem('local'));
} else {
	lang = (window.navigator.language) ? window.navigator.language : 'sk';
	if (lang !== 'sk' && lang !== 'de') {
		lang = 'sk'
	}
	localStorage.setItem('local', JSON.stringify(lang));
}

const messages = {
	sk: {
		title: 'Registrácia žiadostí malých projektov<br>v rámci programu Interreg<br>Slovensko - Rakúsko 2021-2027',
		universalTxt: {
			closeBtn: 'Zavrieť',
			saveBtn: 'Uložiť',
			delete: 'Zmazať',
			logout: 'Odhlásiť',
			edit: 'Editovať',
			edit_final: '',
			exportDatabank: 'Export databázy',
			emptyExport: 'Žiadny obsah na export',
			visible_on: 'Zviditeľniť',
			visible_off: 'Skryť'
		},
		attachmentOptions: {
			dir_1: 'Prílohy žiadateľa',
			dir_2: 'Prílohy žiadateľa týkajúce sa rozpočtu',
			dir_3: 'Prílohy nahrané administrátorom',
			dir_4: 'Prílohy nahrané po realizácií projektu',
		},
		homepage: {
			registration_q: 'Nie ste registrovaní?',
			register: 'Registrujte sa',
			cz: 'Slovensky',
			de: 'Nemecky'
		},
		passwordReset: {
			title: 'Obnova hesla',
			message: 'Vyplňte svoj registračný e-mail a my vám naň pošleme nové heslo.',
			reset: 'Obnoviť heslo',
			change: 'Zmeniť heslo',
			passwdTest: 'Overenie hesla',
			passwd: 'Heslo',
			login: 'Prihláste sa'
		},
		login: {
			title: 'Prihláste sa',
			login: 'Prihlásiť',
			passwdForget: 'Zabudli ste heslo?'
		},
		registration: {
			reg: 'Registrujte sa',
			email: 'E-mail',
			pswd: 'Heslo',
			pswdTest: 'Overenie hesla',
			regBtn: 'Registrovať',
			login: 'Ste už registrovaní a chcete sa prihlásiť?',
			backToHp: 'Späť na úvodnú stránku',
		},
		registrationConfirm: {
			login: 'Prihláste sa'
		},
		projects: {
			title: 'Projekty',
			newProject: 'Vytvoriť nový projekt',
			downloadBtn: 'Exportovať do PDF',
			attachments: 'Prílohy',
			addAttachmentTitle: 'Nahrajte prílohy do ',
			infoAboutUploadFile: 'Je povolené nahrávať súbory nasledujúceho typu: .png, .jpg,  .pdf, .xlsx, .docx, .xls, .ppt, .doc, .odt, .ods, .rar, .zip.',
			maxFileSize: 'Maximálna veľkosť nahrávaných súborov je <b>128 MB</b>.',
			fileCompress: 'Objemné súbory dostatočne skomprimujte do *.zip alebo *.rar súboru.',
			phase_1: '1.) Vyplniť formulár',
			phase_2: '2.) Stiahnuť vyplnený formulár',
			phase_3: '3.) Nahrať prílohy',
			phase_4: '4.) Predloženie a registrácia konečnej verzie projektovej žiadosti',
			checkProjectBtn: 'Odoslať kompletnú projektovú žiadosť vrátane príloh',
			checkProjectBtn1: 'Odoslať opravenú žiadosť na opätovné zaregistrovanie',
			messageSend: 'Formulár bol odoslaný na zaregistrovanie',
			deleteItem: 'Naozaj zmazať?',
			tableColDate: 'Podanie žiadosti',
			tableColCall: 'Výzva č.',
			tableColRegN: 'Reg. č.',
			tableColName: 'Názov',
			tableColUserName: 'Žiadateľ',
			tableColState: 'Stav',
			documents: 'Projektová dokumentácia',
			confirmText: 'Žiadosť o malý projekt bude teraz podaná a odoslaná na zaregistrovanie. Po odoslaní už nebude možné editovať žiadosť o malý projekt. Prajete si pokračovať?',
			form: {
				title: 'Žiadosť o malý projekt je potrebné vyplniť v slovenskom aj v nemeckom jazyku. Vyplňte prosím všetky políčka formulára - políčka označené ”de” v nemčine, “sk” v slovenčine. Políčka bez označenia sú dvojjazyčné - stačí vyplniť raz.',
				ttl_1: '1. VŠEOBECNÉ ÚDAJE O PROJEKTE',
				ttl_2: '2. ÚDAJE O ŽIADATEĽOVI',
				ttl_3: 'ÚDAJE O PROJEKTOVOM PARTNEROVI č.',
				ttl_4: 'ÚDAJE O PROJEKTE',
				ttl_5: 'KVALITA CEZHRANIČNEJ SPOLUPRÁCE',
				ttl_6: 'NÁVRH ROZPOČTU',
				showPartner2: 'Pridať projektového partnera č. 2',
				removePartner2: 'Odstrániť projektového partnera č. 2',
				ph_2_4_number: 'Číslo účtu',
				ph_2_4_code: 'Kód banky',
				ph_2_4_iban: 'IBAN',
				ph_2_4_bic_swift: 'BIC/SWIFT',
				ph_2_5_contact: 'Meno, priezvisko | Vorname, Nachname',
				ph_2_8_contact: 'Meno, priezvisko | Vorname, Nachname',
				ph_2_5_tel: 'Telefón | Telefon (+421, +43)',
				ph_2_5_email: 'E-mail',
				check_2_6_a: 'Žiadateľ má podľa platného právneho stavu nárok na odpočet DPH za činnosti, ktoré budú v rámci projektu vykonávané.',
				check_2_6_c: 'Žiadateľ má skúsenosti s realizáciou cezhraničných projektov.',
				check_2_6_d: 'Projekt je v súlade s pravidlami štátnej pomoci a národného spolufinancovania.',
				check_2_6_e: 'Žiadateľ si uplatňuje paušálnu sumu na náklady na zamestnancov.',
				check_2_6_f: 'Žiadateľ vyhlasuje, že počas realizácie projektu bude mať zamestnanú aspoň 1 osobu.',
				check_3_7_experience_crossborder: 'Partner má skúsenosti s realizáciou cezhraničných projektov.',
				check_3_7_own_application: 'Partner predloží vlastnú projektovú žiadosť (malý projekt B).',
				project_duration: 'Doba realizácie projektu | Projektlaufzeit',
				project_result: 'Ukazovatele výstupu a výsledku | Output- und Ergebnisindikatoren',
				project_result_small: 'Ukazovatele výstupov RCO81 a RCO115 merajú priame výsledky dosiahnuté realizáciou projektu. V závislosti od typu podujatia rozhodnite, či budete počítať počet verejných podujatí ALEBO počet účastníkov. Ukazovateľ výsledku RCR85 popisuje počet účastí (osôb) na spoločných cezhraničných podujatiach po ukončení projektu. Viac informácií nájdete v príručke, kap. 2.2.',
				scheduledStart: 'Začiatok realizácie projektu | Beginn der Projektumsetzung',
				scheduledEnd: 'Ukončenie realizácie projektu | Ende der Projektumsetzung <small>(najneskôr 12 mesiacov od začiatku | spätestens 12 Monate nach Beginn)</small>',
				numberOfCall: 'Číslo výzvy',
				deleteProject: 'Zmazať projekt',
				finance_2: 'Požadovaný finančný príspevok z EFRR, max. 80 %',
				finance_3: 'Finančný príspevok žiadateľa a jeho partnerov, min. 20 %',
				finance_amount: 'suma v EUR',
				finance_percent: '% podiel',
				finance_resources: 'Finančné zdroje',
				finance_contribution: 'Finančný príspevok žiadateľa sa skladá z:',
				finance_contribution_2: 'Finančný príspevok partnera pri spoločnom financovaní',
				finance_contribution_2_max_warning: 'Finančný príspevok partnera činí min. 5 % celkových nákladov na projekt.',
				export_visibility_0: 'Nepodaný',
				export_visibility_1: 'Podaný',
				unit_cost: 'Celkové jednotkové náklady',
				total_budget: 'Celkové náklady na projekt'
			},
			results: {
				rco_77: 'Output / RCO77 / Anzahl der unterstützten kulturellen und touristischen Stätten / Zielwert',
				rcr_77: 'Ergebnis / RCR77 / Besucher von unterstützten kulturellen und touristischen Stätten  / Zielwert',
				rco_83: 'Output / RCO83 / Gemeinsam entwickelte Strategien und Aktionspläne  / Zielwert',
				rcr_79: 'Ergebnis / RCR79 / Von Organisationen aufgegriffene gemeinsame Strategien und Aktionspläne  / Zielwert',
				rco_87: 'Output / RCO87 / Grenzüberschreitend kooperierende Organisationen  /  Zielwert',
				rcr_84: 'Ergebnis / RCR84 / Organisationen, die nach Projektabschluss grenzüberschreitend zusammenarbeiten  / Zielwert',
				rco_116: 'Output / RCO116 / Gemeinsam entwickelte Lösungen  / Zielwert',
				rcr_104: 'Ergebnis / RCR104 / Von Organisationen aufgegriffene bzw. ausgebaute Lösungen  / Zielwert',
				rco_81: 'Účasti na spoločných cezhraničných akciách/ Teilnahmen an grenzüberschreitenden gemeinsamen Aktionen - RCO 81',
				rco_81_small: 'Indikátor počíta počet účastníkov spoločných cezhraničných aktivít = počet zapojených osôb z konkrétnej cieľovej skupiny, ktorými môžu byť napr. obyvatelia, dobrovoľníci, študenti, žiaci alebo odborníci. Nezapočítavajú sa interné pracovné stretnutia partnerov. Príklad: Workshop pre uzavretú skupinu odborníkov s 20 účastníkmi. RCO81 = 20',
				rcr_85: 'Účasti na spoločných cezhraničných akciách po dokončení projektu/ Teilnahmen an grenzüberschreitenden gemeinsamen Aktionen nach Projektabschluss - RCR 85',
				rcr_85_small: 'Tento indikátor počíta účasti (počet účastníkov) na spoločných cezhraničných aktivitách uskutočnených do jedného roka po ukončení projektov. Príklad: Výmenné stretnutie pre 20 študentov, ktoré organizujú bývalí projektoví partneri. RCR85 = 20',
				rco_115: 'Spoločne organizované cezhraničné verejné podujatia/ Gemeinsam veranstaltete grenzübergreifende öffentliche Veranstaltungen - RCO115',
				rco_115_small: 'Indikátor počíta počet podujatí organizovaných pre širokú verejnosť. Príklad: 1 záverečné podujatie, na ktoré je verejnosť z oboch strán hranice pozvaná prostredníctvom webových stránok. RCO115 = 1',
				description: 'Beschreibung des Zielwertes (max. 700 Zeichen)',
			},
			activities: {
				addBtn: 'Pridať',
				removeBtn: 'Odobrať'
			},
			attachment_items: {
				at_0a: 'B1a: Doklad o právnej subjektivite žiadateľa',
				at_0: 'B1b: Doklad o právnej subjektivite partnerov',
				at_1a: 'B2a: Doklad o oprávnení žiadateľa zastupovať organizáciu, ak nie je uvedené v B1a',
				at_1: 'B2b: Doklad o oprávnení partnera zastupovať organizáciu, ak nie je uvedené v B1b',
				at_2: 'B3: Dohoda o partnerstve',
				at_3: 'B4b: Čestné vyhlásenie žiadateľa',
				at_4: 'B5: Rozpočet projektu – list 1, prehľad cenových ponúk - list 2',
				at_5: 'B6: <strike>Prísľub národného spolufinancovania</strike> (platí pre rakúskych žiadateľov)',
				at_6: 'B7: Cenové ponuky, prieskum trhu'
			},
			popovers: {
				legal_form_2: 'Český žiadateľ vyplní právnu formu organizácie podľa prílohy A1, rakúsky žiadateľ vyplní právnu formu organizácie.',
				other_data_4: 'pozri Príručku pre FMP bod 1.11.',
				cross_border: 'Projekt musí spĺňať aspoň tri z štyroch kritérií spolupráce. Povinné je splnenie dvoch nasledujúcich kritérií.',
				results: 'Pokyny sú uvedené v Príručke pre FMP, bod 2.3',
				budget: 'Podrobný rozpočet projektu je povinnou prílohou B5, tu sa uvádzajú súhrnné čísla z prílohy B5',
				attachment: 'Názvy nahraných súborov budú začínať kódom podľa zoznamu príloh (napr. B5-rozpočet projektu.pdf). pozri Príručku pre FMP bod 4.3'
			}
		},
		preview: {
			stateLabel: 'Stav projektu',
			downloadBtn: 'Exportovať žiadosť do PDF',
			logHistory: 'História stavov',
			stateLabelAdmin: 'Admin',
			stateLabelUser: 'Užívateľ',
			changeState: 'Naozaj chcete zmeniť stav?',
			zipAttachments: 'Archivovať všetky prílohy',
			zipAttachmentsDownload: 'Stiahnuť archív',
		},
		statesBtn: {
			all_filter: 'Stav (všetky)',
			registered: 'Žiadosť zaregistrovaná',
			correction_1: 'Žiadosť vrátená na prepracovanie',
			fix_1: 'Opravená žiadosť opätovne zaregistrovaná',
			accepted: 'Formálne náležitosti splnené',
			refused_formal: 'Formálne náležitosti nesplnené',
			quality_complied: 'Kritériá kvality a cezhraničného dopadu splnené',
			quality_refused: 'Kritériá kvality a cezhraničného dopadu nesplnené',
			refused: 'Projekt pozastavený RMV, doporučený na prepracovanie',
			running_comments: 'Projekt schválený RMV s pripomienkami',
			running: 'Projekt schválený RMV',
			refused_rmv: 'Projekt zamietnutý RMV',
			contract: 'Podpísaná zmluva o financovaní',
			unrealized: 'Projekt nerealizovaný',
			certificate: 'Vydané osvedčenie Správcom/FLC',
			report: 'Projekt v záverečnej správe',
			paid: 'EFRR preplatené',
			sustainability: 'Správa udržateľnosti'
		},
		footer: {
			text: ''
		},
		settings: {
			title: 'Nastavenia',
			number_1: 'Číslo výzvy',
			date: 'Dátum zasadnutia',
			tooltip: 'Slúži na nastavenie aktuálneho čísla výzvy.'
		},
		messages: {
			success: 'Zmena prebehla úspešne',
			error: 'Operácia sa nepodarila',
			file_uploaded: 'Súbor bol úspešne nahraný.',
			deleted: 'Položka bola zmazaná',
			wrong_login: 'Účet neexistuje alebo nebol aktivovaný vo vašej e-mailovej schránke.',
			pswd_not_same: 'Heslá sa nezhodujú',
			pswd_empty: 'Heslo nesmie byť prázdne',
			automatic_save: 'Formulár bol automaticky uložený'
		},
		navbar: {
			users: 'Užívatelia',
			projects: 'Projekty',
			meetings: 'Zasadnutia RMV',
		},
		users: {
			title: 'Užívatelia',
			name: 'Meno',
			email: 'E-mail',
			tel: 'Telefón',
			permissions: 'Oprávnenia',
			changePswd: 'Zmeniť heslo?',
			newPswd: 'Nové heslo',
			newPswdControl: 'Potvrdiť nové heslo',
			role: {
				admin: 'Admin',
				user: 'Žiadateľ',
				'read-only': 'Pozorovateľ',
				'read-only-2': 'Kontrola',
				'meetings-only': 'Člen výboru',
			}
		},
		meetings: {
			title: 'Zasadnutia RMV',
			tableDateCol: 'Dátum zasadnutia',
			tableName: 'Názov zasadnutia',
			addMeeting: 'Pridať zasadnutie',
		},
		apiMessages: {
			user_already_exist : "Žiadateľ s týmto e-mailom už existuje.",
			empty : "Prázdne registračné údaje",
			confirm : "Potvrďte registráciu v doručenom e-maile a následne sa prihláste. <br>(Doručenie e-mailu môže trvať aj niekoľko minút.)",
			something_went_wrong : "Niečo sa pokazilo",
			reg_confirm_err : "Nie ste zaregistrovaní.",
			reg_confirm_succes : "Overenie registrácie prebehlo úspešne.",
			err : "Niečo sa pokazilo. Obráťte sa na správu webu",
			not_exist : "Účet s týmto e-mailom neexistuje",
			reset_email_sent : "Bol vám odoslaný e-mail na obnovenie hesla."
		}
	},
	de: {
		title: 'Registrierung von Anträgen für Kleinprojekte<br> im Rahmen des Programms Interreg<br> Slowakei - Österreich 2021-2027',
		universalTxt: {
			closeBtn: 'Schließen',
			saveBtn: 'Speichern',
			delete: 'Löschen',
			logout: 'Abmelden',
			edit: 'Bearbeiten',
			edit_final: '',
			exportDatabank: 'Datenbank Export',
			emptyExport: 'Kein Inhalt zu exportieren',
			visible_on: 'Sichtbar machen',
			visible_off: 'Ausblenden',
		},
		attachmentOptions: {
			dir_1: 	'Anhänge vom Antragsteller',
			dir_2: 	'Anhänge vom Antragsteller zum Budget',
			dir_3: 'Vom Administrator hochgeladene Anhänge',
			dir_4: 'Nach Projektdurchführung hochgeladene Anhänge'
		},
		homepage: {
			registration_q: 'Sind Sie nicht registriert?',
			register: 'Registrieren Sie sich',
			cz: 'Slowakisch',
			de: 'Deutsch'
		},
		passwordReset: {
			title: 'Passwort erneuern',
			message: 'Füllen Sie Ihre Registrierungs-E-Mail aus und wir senden Ihnen ein neues Passwort zu.',
			reset: 'Passwort erneuern',
			change: 'Passwort ändern',
			passwdTest: 'Passwortüberprüfung',
			passwd: 'Passwort',
			login: 'Anmeldung'
		},
		login: {
			title: 'Anmeldung',
			login: 'Melden Sie sich an',
			passwdForget: 'Haben Sie Passwort vergessen?'
		},
		registration: {
			reg: 'Registrieren Sie sich',
			email: 'E-mail',
			pswd: 'Passwort',
			pswdTest: 'Passwortüberprüfung',
			regBtn: 'Sich registrieren',
			login: 'Sie sind bereits registriert und möchten sich anmelden?',
			backToHp: 'Zurück zur Startseite',
		},
		registrationConfirm: {
			login: 'Melden Sie sich an'
		},
		projects: {
			title: 'Projekte',
			newProject: 'Neues Projekt anlegen',
			downloadBtn: 'In PDF exportieren',
			attachments: 'Anhänge',
			addAttachmentTitle: 'Anhänge hochladen zu ',
			infoAboutUploadFile: 'Folgende Dateitypen dürfen hochgelden werden: .png, .jpg,  .pdf, .xlsx, .docx, .xls, .ppt, .doc, .odt, .ods, .rar, .zip.',
			maxFileSize: 'Die maximale Größe der hochgeladenen Dateien beträgt <b>128 MB</b>.',
			fileCompress: 'Komprimieren Sie große Dateien ausreichend in eine .zip oder .rar Datei.',
			phase_1: '1.) Ausfüllen des Antragsformulars',
			phase_2: '2.) Das ausgefüllte Formular herunterladen',
			phase_3: '3.) Hochladen von Anhängen',
			phase_4: '4.) Einreichung und Registrierung der endgültigen Version des Projektantrags',
			checkProjectBtn: 'Vollständigen Projektantrag samt Anhängen absenden',
			checkProjectBtn1: 'Bearbeiteten Projektantrag zur Neuregistrierung senden',
			messageSend: 'Das Formular wurde zur Registrierung gesendet',
			deleteItem: 'Wirklich löschen?',
			tableColDate: 'Einreichung des Projektantrags',
			tableColCall: 'Einreichrunde Nr.',
			tableColRegN: 'Reg. Nr.',
			tableColName: 'Titel',
			tableColUserName: 'Antragsteller',
			tableColState: 'Status',
			documents: 'Projektdokumentation',
			confirmText: 'Der Kleinprojektantrag wird nun eingereicht und zur Registrierung weitergeleitet. Sobald der Kleinprojektantrag zur Registrierung gesendet wurde, kann er nicht mehr bearbeitet werden. Möchten Sie fortfahren?',
			form: {
				title: 'Der Kleinprojektantrag muss sowohl auf Slowakisch als auch auf Deutsch ausgefüllt werden. Bitte füllen Sie alle Felder des Formulars aus, die mit „de“ gekennzeichnet auf Deutsch und mit „sk“ auf Slowakisch. Felder ohne Kennzeichnung sind zweisprachig - bitte nur einmal ausfüllen.',
				ttl_1: '1. ALLGEMEINE INFORMATIONEN ÜBER DAS PROJEKT',
				ttl_2: '2. ANGABEN ZUM ANTRAGSTELLER',
				ttl_3: 'ANGABEN ZUM PROJEKTPARTNER Nr.',
				ttl_4: 'ANGABEN ZUM PROJEKT',
				ttl_5: 'QUALITÄT DER GRENZÜBERSCHREITENDEN ZUSAMMENARBEIT',
				ttl_6: 'BUDGETENTWURF',
				showPartner2: 'Projektpartner Nr. 2 hinzufügen',
				removePartner2: 'Projektpartner Nr. 2 entfernen' ,
				ph_2_4_number: 'Kontonummer',
				ph_2_4_code: 'Bankcode',
				ph_2_4_iban: 'IBAN',
				ph_2_4_bic_swift: 'BIC/SWIFT',
				ph_2_5_contact: 'Meno, priezvisko | Vorname, Nachname',
				ph_2_8_contact: 'Meno, priezvisko | Vorname, Nachname',
				ph_2_5_tel: 'Telefón | Telefon (+421, +43)',
				ph_2_5_email: 'E-mail',
				check_2_6_a: 'Der Antragsteller ist nach gültiger Rechtslage für die im Projekt durchzuführenden Aktivitäten zum Vorsteuerabzug berechtigt.',
				check_2_6_c: 'Der Antragsteller hat Erfahrungen mit der Umsetzung von grenzüberschreitenden Projekten.',
				check_2_6_d: 'Das Projekt steht im Einklang mit den Vorschriften für staatliche Beihilfe und nationale Kofinanzierung.',
				check_2_6_e: 'Der Antragsteller beansprucht eine Personalkostenpauschale.',
				check_2_6_f: 'Der Antragsteller erklärt, dass er mindestens eine Person für die Dauer des Projekts beschäftigen wird.',
				check_3_7_experience_crossborder: 'Der Partner hat Erfahrungen mit der Umsetzung von grenzüberschreitenden Projekten.',
				check_3_7_own_application: 'Vom Projektpartner wird ein separater Projektantrag eingereicht (Kleinprojekt Typ B).',
				project_duration: 'Doba realizácie projektu | Projektlaufzeit',
				project_result: 'Ukazovatele výstupu a výsledku | Output- und Ergebnisindikatoren',
				project_result_small: 'Outputindikatoren RCO81 und RCO115 messen die direkten Ergebnisse, die durch die Projektumsetzung erzielt werden. Entscheiden Sie je nach Art der Veranstaltung, ob Sie die Anzahl öffentlicher Veranstaltungen ODER die der Teilnehmer zählen werden. Ergebnisindikator RCR85 bewertet die Anzahl der Teilnahmen (Personen) an gemeinsamen grenzüberschreitenden Veranstaltungen nach Abschluss des Projekts. Mehr im Handbuch, Kap. 2.2.',
				scheduledStart: 'Začiatok realizácie projektu | Beginn der Projektumsetzung',
				scheduledEnd: 'Ukončenie realizácie projektu | Ende der Projektumsetzung <small>(najneskôr 12 mesiacov od začiatku | spätestens 12 Monate nach Beginn)</small>',
				numberOfCall: 'Einreichrunde Nr.',
				ttl_1_3: '1.3. ',
				ttl_1_3_1: '1.3.1 ',
				deleteProject: 'Projekt löschen',
				finance_2: 'Beantragte EFRE Förderung, max. 80 %',
				finance_3: 'Finanzieller Beitrag des Antragstellers und seiner Partner, mind. 20 %',
				finance_amount: 'Betrag in EUR',
				finance_percent: '% Anteil',
				finance_resources: 'Finanzierungsquellen',
				finance_contribution: 'Finanzieller Beitrag des Antragstellers bestehend aus:',
				finance_contribution_2_max_warning: 'Der finanzielle Beitrag des Partners beträgt min. 5 % der Projektgesamtkosten.',
				finance_contribution_2: 'Finanzierung des Partners bei gemeinsamer Finanzierung ',
				export_visibility_0: 'Nicht eingereichte',
				export_visibility_1: 'Eingereichte',
				unit_cost: 'Gesamteinheitskosten - gilt nur für tschechische Antragsteller',
				total_budget: 'Projektgesamtkosten'
			},
			results: {
				rco_77: 'Output / RCO77 / Anzahl der unterstützten kulturellen und touristischen Stätten / Zielwert',
				rcr_77: 'Ergebnis / RCR77 / Besucher von unterstützten kulturellen und touristischen Stätten  / Zielwert',
				rco_83: 'Output / RCO83 / Gemeinsam entwickelte Strategien und Aktionspläne  / Zielwert',
				rcr_79: 'Ergebnis / RCR79 / Von Organisationen aufgegriffene gemeinsame Strategien und Aktionspläne  / Zielwert',
				rco_87: 'Output / RCO87 / Grenzüberschreitend kooperierende Organisationen  /  Zielwert',
				rcr_84: 'Ergebnis / RCR84 / Organisationen, die nach Projektabschluss grenzüberschreitend zusammenarbeiten  / Zielwert',
				rco_116: 'Output / RCO116 / Gemeinsam entwickelte Lösungen  / Zielwert',
				rcr_104: 'Ergebnis / RCR104 / Von Organisationen aufgegriffene bzw. ausgebaute Lösungen  / Zielwert',
				rco_81: 'Účasti na spoločných cezhraničných akciách/ Teilnahmen an grenzüberschreitenden gemeinsamen Aktionen - RCO 81',
				rco_81_small: 'Der Indikator zählt die Anzahl der Teilnehmenden an gemeinsamen grenzübergreifenden Aktionen = die Anzahl der beteiligten Personen einer bestimmten Zielgruppe, bei denen es sich z. B. um Einwohner, Freiwillige, Studenten, Schüler, Experten handeln kann. Nicht zu zählen sind interne Managementtreffen der Partner. Beispiel: Workshop für eine geschlossene Gruppe von Fachleuten mit 20 Teilnehmenden. RCO81 = 20',
				rcr_85: 'Účasti na spoločných cezhraničných akciách po dokončení projektu/ Teilnahmen an grenzüberschreitenden gemeinsamen Aktionen nach Projektabschluss - RCR 85',
				rcr_85_small: 'Dieser Indikator zählt die Teilnahmen (Anzahl der Teilnehmenden) an gemeinsamen grenzüberschreitenden Aktionen innerhalb eines Jahres nach Abschluss der Projekte. Beispiel: Austauschtreffen für 20 Studenten, das von den ehemaligen Projektpartnern organisiert wird. RCR85 = 20',
				rco_115: 'Spoločne organizované cezhraničné verejné podujatia/ Gemeinsam veranstaltete grenzübergreifende öffentliche Veranstaltungen - RCO115',
				rco_115_small: 'Der Indikator zählt die Anzahl der Veranstaltungen, die für die breite Öffentlichkeit organisiert werden. Beispiel: 1 Abschlussveranstaltung, zu der die Öffentlichkeit beiderseits der Grenze öffentlich über Websites eingeladen wird. RCO115 = 1',
				description: 'Beschreibung des Zielwertes (max. 700 Zeichen)',
			},
			activities: {
				addBtn: 'Hinzufügen',
				removeBtn: 'Entfernen'
			},
			attachment_items: {
				at_0a: 'B1a: Nachweis der Rechtspersönlichkeit des Antragstellers',
				at_0: 'B1b: Nachweis der Rechtspersönlichkeit aller Partnerorganisationen',
				at_1a: 'B2a: Nachweis der Vertretungsberechtigung des Antragstellers, falls nicht aus B1a ersichtlich',
				at_1: 'B2b: Nachweis der Vertretungsberechtigung aller Partnerorganisationen, falls nicht aus B1b ersichtlich',
				at_2: 'B3: Partnerschaftsvereinbarung',
				at_3: 'B4a: Ehrenerklärung des Antragstellers',
				at_4: 'B5: Projektkostenplan – Tabelle 1, Preisangebotsübersicht – Tabelle 2',
				at_5: 'B6: Nationale Kofinanzierungserklärung – gilt für österreichische Antragsteller',
				at_6: 'B7: Preisauskünfte, Marktrecherche'
			},
			popovers: {
				legal_form_2: 'Tschechischer Antragsteller füllt die Rechtsform der Organisation laut Anhang A1 aus, österreichischer Antragsteller füllt die Rechtsform der Organisation aus.',
				other_data_4: 'Siehe Handbuch für KPF Punkt 1.11',
				cross_border: 'Das Projekt muss mindestens drei von vier Kooperationskriterien erfüllen. Verpflichtend ist die Erfüllung folgender beiden Kriterien.',
				results: 'Hinweise sind im Handbuch für KPF, Punkt 2.3 angeführt',
				budget: 'Ein detaillierter Projektkostenplan ist ein verpflichtender Anhang B5, hier werden die zusammengefassten Zahlen aus dem Anhang B5 angegeben',
				attachment: 'Die Namen der hochgeladenen Dateien beginnen mit dem Code, der in der Liste der Anhänge angegeben ist (z.B. B5-Projektbudget.pdf) - siehe Handbuch für KPF Punkt 4.3'
			}
		},
		preview: {
			stateLabel: 'Projektstatus',
			downloadBtn: 'Den Projektantrag in PDF exportieren',
			logHistory: 'Statusverlauf',
			stateLabelAdmin: 'Admin',
			stateLabelUser: 'User',
			changeState: 'Wirklich Projektstatus ändern?',
			zipAttachments: 'Alle Anhänge archivieren',
			zipAttachmentsDownload: 'Download des Archivs'
		},
		statesBtn: {
			all_filter: 'Projektstatus (alle Möglichkeiten)',
			registered: 'Projektantrag registriert',
			correction_1: 'Projektantrag zur Überarbeitung retourniert',
			fix_1: 'Korrigierter Projektantrag neu registriert',
			accepted: 'Formale Anforderungen erfüllt',
			refused_formal: 'Formale Anforderungen nicht erfüllt',
			quality_complied: 'Kriterien Qualität und gü. Wirkung erfüllt',
			quality_refused: 'Kriterien Qualität und gü. Wirkung nicht erfüllt',
			refused: 'vom RLA zurückgestellt, zur Überarbeitung empfohlen',
			running_comments: 'vom RLA mit Auflagen genehmigt ',
			running: 'vom RLA genehmigt',
			refused_rmv: 'vom RLA abgelehnt',
			contract: 'Finanzierungsvertrag unterfertigt',
			unrealized: 'Projekt nicht umgesetzt',
			certificate: 'Bescheinigung durch Verwalter/FLC ausgestellt',
			report: 'Projekt im Bericht der Verwalter',
			paid: 'EFRE-Mittel ausbezahlt',
			sustainability: 'Dauerhaftigkeitsbericht'
		},
		footer: {
			text: ''
		},
		settings: {
			title: 'Einstellung',
			number_1: 'Einreichrunde Nr.',
			date: 'Datum der Sitzung',
			tooltip: 'Dient zur Einstellung der aktuellen Einreichrunde Nummer.'
		},
		messages: {
			success: 'Die Änderung war erfolgreich',
			error: 'Der Vorgang ist fehlgeschlagen',
			file_uploaded: 'Die Datei wurde erfolgreich hochgeladen.',
			deleted: 'Position wurde gelöscht.',
			wrong_login: 'Das Konto existiert nicht oder wurde nicht in Ihrem E-Mail-Posteingang aktiviert.',
			pswd_not_same: 'Die Passwörter stimmen nicht überein',
			pswd_empty: 'Passwort darf nicht leer sein',
			automatic_save: 'Das Formular wurde automatisch gespeichert',
		},
		navbar: {
			users: 'Benutzer',
			projects: 'Projekte',
			meetings: 'Sitzungen',
		},
		users: {
			title: 'Benutzer',
			name: 'Name',
			email: 'E-Mail',
			tel: 'Telefon',
			permissions: 'Berechtigung',
			changePswd: 'Passwort ändern?',
			newPswd: 'Neues Passwort',
			newPswdControl: 'Neues Passwort bestätigen',
			role: {
				admin : 'Admin',
				user : 'Antragsteller',
				'read-only' : 'Beobachter',
				'read-only-2': 'Kontrolle',
				'meetings-only' : 'Mitglied des Ausschusses',
			}
		},
		meetings: {
			title: 'Sitzung',
			tableDateCol: 'Datum der Sitzung',
			tableName: 'Name der Sitzung',
			addMeeting: 'Sitzung hinzufügen',
		},
		apiMessages: {
			user_already_exist : "Antragsteller mit dieser E-Mail existiert bereits.",
			empty : "Leere Registrierungsangaben",
			confirm : "Bestätigen Sie Ihre Registrierung in der E-Mail die Sie erhalten haben, und melden Sie sich anschließend an. <br>(Übermittlung der E-Mail kann ein paar Minuten dauern.)",
			something_went_wrong : "Etwas ist schief gelaufen",
			reg_confirm_err : "Sie sind nicht registriert.",
			reg_confirm_succes : "Die Überprüfung der Registrierung war erfolgreich.",
			err : "Etwas ist schief gelaufen. Bitte kontaktieren Sie die Website-Verwaltung.",
			not_exist : "Das Konto mit dieser E-Mail existiert nicht",
			reset_email_sent : "Es wurde an Sie eine E-Mail gesendet, um Ihr Passwort zurückzusetzen."
		}
	}
}


const i18n = new VueI18n({
	locale: lang,
	messages
});

export default i18n;
